import React from 'react';
import SideMenuDrawerHeader from './SideMenuDrawerHeader';
import SideMenuDrawerList from './SideMenuDrawerList';
import MuiDrawer, { DrawerProps as IMuiDrawerProps } from '@mui/material/Drawer';
import { styled, Theme as IMuiTheme, CSSObject } from '@mui/material/styles';
import { Grid, Divider } from '@mui/material';
import { ISideMenuProps } from './SideMenu';
import { useSideMenuProvider } from './SideMenuProvider';

/*
*   Боковое меню
*/

type IDrawerProps = {
    drawerwidth: number,
} & IMuiDrawerProps

const openedMixin = (theme: IMuiTheme, drawerwidth: number | undefined): CSSObject => ({
    width: drawerwidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme: IMuiTheme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(9)} + 1px)`,
    },
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })<IDrawerProps>(
    ({ theme, open, drawerwidth }) => ({
        width: drawerwidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        '.MuiDrawer-paper': {
            backgroundColor: '#F4F5F7',
        },
        ...(open && {
            ...openedMixin(theme, drawerwidth),
            '& .MuiDrawer-paper': openedMixin(theme, drawerwidth),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);


export default function SideMenuDrawer({ topData, middleData, bottomData }: ISideMenuProps) {
    const { openSideMenu, handleToggleSideMenu, drawerwidth } = useSideMenuProvider();
    return (
        <Drawer variant="permanent"
            open={openSideMenu}
            drawerwidth={drawerwidth}>
            {/* Top Menu */}
            <Grid mt={7}>
                <SideMenuDrawerList
                    menuItemList={topData}
                />
            </Grid>


            <Grid style={{ marginTop: 'auto' }}>
                {/* Middle Menu */}
                <SideMenuDrawerList
                    menuItemList={middleData}
                />
                <Divider />

                {/* Bottom Menu */}
                <SideMenuDrawerList
                    menuItemList={bottomData}
                />

                {/* Выбор языка, временно отключили (12.05.2022) */}
                {/* <LanguageMenu /> */}

                {/* Контрол сворачивания / разворачивания меню */}
                <SideMenuDrawerHeader
                    openSideMenu={openSideMenu}
                    handleSideMenuClick={handleToggleSideMenu}
                />
            </Grid>
        </Drawer >
    );
}
